import React from "react";
import styles from "./ListaTorneosDecada.module.css";

const ListaTorneosDecada = (props) => {
  const decada = props.decada;

  const torneoElegidoHandler = (event) => {
    props.onTorneoElegido(decada.torneos[event.target.id]);
  };

  return (
    <div className={`${styles.listado}`}>
      {decada.torneos && decada.torneos.map((torneo, index) => (
        <button
          className={`${styles.torneo}`}
          key={index}
          id={index}
          onClick={torneoElegidoHandler}
          value={torneo.descripcion}
        >
          {torneo.descripcion}
        </button>
      ))}
    </div>
  );
};

export default ListaTorneosDecada;
